import { Injectable } from '@angular/core';

@Injectable()
export class PlaceholderFieldsService {

  constructor() { }
  get()
  {
  	return [
      {
        key: 'text',
        type: 'input',
        templateOptions: {
          label: 'Wait',
          placeholder: 'Please wait..loading..'
        }
      }
    ]
  }

}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/placeholder-fields.service.ts